// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getHeaders } from "../silentAuth";
import { graphConfig } from "../../apiConfig";

/**
 * Attaches a given access token to a Microsoft Graph API call. Returns information about the user
 */

const scopes = {
  scopes: ["User.Read"],
};

// Define a service using a base URL and expected endpoints
export const graphApi = createApi({
  reducerPath: "graphApi",
  baseQuery: fetchBaseQuery({
    baseUrl: graphConfig.graphMeEndpoint,
    prepareHeaders: async (headers, { getState }) => {
      return await getHeaders(scopes, headers);
    },
  }),
  endpoints: (builder) => ({
    getUser: builder.query<any, void>({
      query: () => `/me`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUserQuery: useGetCurrentUserQuery } = graphApi;
